import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, LazyMotion, domAnimation, m, useReducedMotion } from 'framer-motion';
import { ACTIVE_ROUTE_MOTION_PROFILE, ROUTE_MOTION_PROFILES } from '../../lib/motion';
import ErrorBoundary from '../ErrorBoundary';

export default function AnimatedPageOutlet() {
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  const profile = ROUTE_MOTION_PROFILES[ACTIVE_ROUTE_MOTION_PROFILE];

  const variants = reduceMotion
    ? {
        initial: { opacity: 1, y: 0 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 1, y: 0 },
      }
    : {
        initial: { opacity: 0, y: profile.enterY, filter: `blur(${profile.blurPx}px)` },
        animate: { opacity: 1, y: 0, filter: 'blur(0px)' },
        exit: { opacity: 0, y: profile.exitY, filter: `blur(${profile.blurPx}px)` },
      };

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence mode="wait" initial={false}>
        <m.div
          key={location.pathname}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants}
          transition={{
            duration: reduceMotion ? 0 : profile.duration,
            ease: profile.ease,
          }}
        >
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </m.div>
      </AnimatePresence>
    </LazyMotion>
  );
}
